import { createFileRoute } from '@tanstack/react-router'
import { useAuth } from '@workos-inc/authkit-react'
import { useEffect } from 'react'

export const Route = createFileRoute('/login')({ component: LoginRoute })

function LoginRoute() {
  const { signIn } = useAuth()
  useEffect(() => {
    void signIn()
  }, [signIn])
  return (
    <div className="flex min-h-screen items-center justify-center">
      <p className="text-muted-foreground">Redirecting...</p>
    </div>
  )
}
